export default "__VITE_ASSET__bca52ff7__"